const moment = require("moment");

const getToken = () => {
    return sessionStorage.getItem('token') || localStorage.getItem('token') || null;
}

const getUserDetail = () => {
    return JSON.parse(sessionStorage.getItem('user_detail')) || JSON.parse(localStorage.getItem('user_detail')) || null;
}

const getUserType = () => {
    if (sessionStorage.getItem('user_detail')) {
        return JSON.parse(sessionStorage.getItem('user_detail'))['type'];
    } else if (localStorage.getItem('user_detail')) {
        return JSON.parse(localStorage.getItem('user_detail'))['type'];
    } else {
        return 0;
    }
}

const removeUserSession = () => {
    if (sessionStorage.getItem('user_detail')) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user_detail');
    } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user_detail');
    }
}

const setUserSession = (token, user, setSession = false) => {
    if (setSession) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user_detail', JSON.stringify(user));
    } else {
        localStorage.setItem('token', token);
        localStorage.setItem('user_detail', JSON.stringify(user));
    }
}

const setUserDetail = (user) => {
    localStorage.setItem('user_detail', JSON.stringify(user));
}

const is_login = () => {
    if (sessionStorage.getItem('token') || localStorage.getItem('token')) {
        return true;
    } else {
        return false;
    }
}

const amountFormatUse = (amount, digits = 2) => {
    if (amount) {
        return '₹' + parseFloat(amount).toFixed(digits);
    } else {
        return '₹' + parseFloat(0).toFixed(digits);
    }
}
const amountFormat = (amount) => {
    if (amount) {
        return parseFloat(amount).toFixed(2);
    } else {
        return parseFloat(0).toFixed(2);
    }
}

const img_view = (img, width = '', height = '', auto = true) => {
    return process.env.REACT_APP_IMG_URL + 'uploads/' + img
    // if (auto) {
    //     return process.env.REACT_APP_IMG_URL + 'img?img=' + img + '&w=' + width + '&h=' + height
    // } else {
    //     return process.env.REACT_APP_IMG_URL + 'uploads/' + img
    // }
}
const Date_format = (date) => {
    var new_date = new Date(date),
        mnth = ("0" + (new_date.getMonth() + 1)).slice(-2),
        day = ("0" + new_date.getDate()).slice(-2);
    return [new_date.getFullYear(), mnth, day].join("-");
}


const IsModemAccess = (modem_name, type) => {
    if (getUserDetail()) {
        var modem = getUserDetail()?.['roleAssigned'];
        if (modem && modem[modem_name] && modem[modem_name].module[type] === 1) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

const utc_local = (data_time, format = "DD/MM/YYYY HH:mm:ss") => {
    if (data_time) {
        return moment.utc(data_time).local().format(format);
    } else {
        return '';
    }
}

const formatLocalDateToYYYYMMDD = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const local_utc_timestamp = (localDateStr, includeTime = false) => {
    if (localDateStr) {
        if (includeTime) {
            let localDate = new Date(localDateStr.toISOString().replace('.000Z', ''));
            return localDate.getTime(); // UTC timestamp
        } else {
            var date = formatLocalDateToYYYYMMDD(localDateStr);
            let localDate = new Date(date + 'T00:00:00');
            return localDate.getTime(); // UTC timestamp
        }
    } else {
        return '';
    }
}

const convertDecimalToTime = (decimalHours) => {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);

    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');

    return `${paddedHours}:${paddedMinutes}`;
}

const setDefaultLocale = (locale) => {
    localStorage.setItem('locale', locale);
}

const getDefaultLocale = (locale) => {
    return localStorage.getItem('locale') || 'en';
}

const getLast6MonthsTimestamps = (numner = 5) => {
    const result = [];

    const now = new Date();
    now.setHours(0, 0, 0, 0); // reset to midnight for consistency

    for (let i = numner; i >= 0; i--) {
        const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getTime();
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999).getTime();

        result.push({
            month: date.toLocaleString('default', { month: 'short' }) + ' ' + date.getFullYear(),
            year: date.getFullYear(),
            startTimestamp: startOfMonth,
            endTimestamp: endOfMonth
        });
    }

    return result.reverse();
}

const getLast30DaysWithTimestamps = (Days = 29) => {
    const result = [];
    const today = new Date();
  
    for (let i = 0; i <= Days; i++) {
      const baseDate = new Date();
      baseDate.setDate(today.getDate() - i);
  
      const start = new Date(baseDate);
      start.setHours(0, 0, 0, 0);
  
      const end = new Date(baseDate);
      end.setHours(23, 59, 59, 999);
  
      result.push({
        date: utc_local(start.getTime(),"YYYY-MM-DD"),
        startTimestamp: start.getTime(),
        endTimestamp: end.getTime()
      });
    }
  
    return result; // from oldest to newest
  };


export { convertDecimalToTime, getLast30DaysWithTimestamps, getLast6MonthsTimestamps, setDefaultLocale, getDefaultLocale, utc_local, local_utc_timestamp, IsModemAccess, amountFormatUse, Date_format, img_view, amountFormat, getUserType, getToken, removeUserSession, setUserSession, is_login, getUserDetail, setUserDetail };